/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyAccount} from '../api'

export const useMutationVerifyAccount = createReactQueryMutationHook('verifyAccount', verifyAccount)
